document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu functionality
  const mobileMenuIcon = document.querySelector('.mobile-menu--icon');
  const mobileMenuList = document.querySelector('.mobile-menu--list');
  const mobileMenuOverlay = document.querySelector('.mobile-menu--overlay');
  const mobileMenuItems = document.querySelectorAll('.mobile-menu--list-item.has-dropdown');

  if (mobileMenuIcon && mobileMenuList && mobileMenuOverlay) {
    mobileMenuIcon.addEventListener('click', function () {
      const isExpanded = mobileMenuIcon.getAttribute('aria-expanded') === 'true';
      mobileMenuIcon.setAttribute('aria-expanded', !isExpanded);

      // Toggle menu visibility
      if (!mobileMenuList.classList.contains('active')) {
        // Remove hidden first to allow transition
        mobileMenuList.classList.remove('hidden');

        // Force a reflow to ensure transition works
        mobileMenuList.offsetHeight;

        // Then add active class to trigger transition
        requestAnimationFrame(() => {
          mobileMenuList.classList.add('active');
          mobileMenuOverlay.classList.add('active');
          mobileMenuIcon.classList.add('active');
        });

        document.body.style.overflow = 'hidden';
      } else {
        mobileMenuList.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        mobileMenuIcon.classList.remove('active');
        document.body.style.overflow = '';

        // Wait for transition to complete before hiding
        setTimeout(() => {
          if (!mobileMenuList.classList.contains('active')) {
            mobileMenuList.classList.add('hidden');
          }
        }, 400);
      }
    });
  } else {
    console.error('Mobile menu elements not found!');
  }

  // Add click-away detection for mobile menu (overlay click)
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function () {
      if (mobileMenuList.classList.contains('active')) {
        mobileMenuList.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        mobileMenuIcon.classList.remove('active');
        document.body.style.overflow = '';
        mobileMenuIcon.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
          if (!mobileMenuList.classList.contains('active')) {
            mobileMenuList.classList.add('hidden');
          }
        }, 400);
      }
    });
    // Mobile dropdown functionality
    mobileMenuItems.forEach((item) => {
      const dropdownIcon = item.querySelector('.mobile-dropdown-icon');
      const subMenu = item.querySelector('.mobile-submenu');

      if (dropdownIcon && subMenu) {
        dropdownIcon.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation(); // Prevent click from bubbling up and affecting parent
          const isExpanded = dropdownIcon.getAttribute('aria-expanded') === 'true';
          dropdownIcon.setAttribute('aria-expanded', !isExpanded);
          subMenu.classList.toggle('show');
          dropdownIcon.classList.toggle('rotated');
        });
      }
    });
  }

  // Language switcher mobile touch handling
  const mobileLangSwitcher = document.querySelector(
    '.mobile-language-switcher .language-switcher--list > li.menu-item-has-children'
  );
  if (mobileLangSwitcher) {
    mobileLangSwitcher.addEventListener('click', function (e) {
      // Only prevent default and toggle if clicking the parent item itself
      if (e.target.closest('a') && e.target.closest('a').parentElement === mobileLangSwitcher) {
        e.preventDefault();
        e.stopPropagation();
        mobileLangSwitcher.classList.toggle('active');
      }
    });
  }

  // Close language switcher when clicking outside
  document.addEventListener('click', function (e) {
    if (mobileLangSwitcher && !mobileLangSwitcher.contains(e.target)) {
      mobileLangSwitcher.classList.remove('active');
    }
  });
});
